import {
    axiosNewAjax
} from '@/utils/ajax'
export default class tbEnterpriseConfigApi {
    static queryConfig(data) {
        return axiosNewAjax('get', '/enterprise-service/tbEnterpriseConfig/queryConfig', data)
    }
}


// WEBPACK FOOTER //
// ./src/api/tbEnterpriseConfigApi.js